import script from "./DeliveryQuestionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryQuestionCard.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryQuestionCard.vue?vue&type=style&index=0&id=168514b4&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168514b4"]])

export default __exports__